import React from "react"
import "@fortawesome/fontawesome-svg-core/styles.css"
import "./src/components/Layout.css"
import AgeGate from "./src/components/common/AgeGate"
import { initClickTracking, trackPageView } from "./src/utils/analytics"
import { updateCanonical } from "./src/utils/canonical"

// 年齢確認は全ページ（Layout を使わないページも）に出す
export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <AgeGate />
  </>
)

export const onClientEntry = () => {
  initClickTracking()
}

// page_view はここだけが送る（1回の表示で1回）。最初の読み込みでも呼ばれる（prevLocation は null）
export const onRouteUpdate = ({ location, prevLocation }) => {
  updateCanonical(location)

  // 目次の #見出し だけの移動はページの閲覧に数えない
  if (
    prevLocation &&
    prevLocation.pathname === location.pathname &&
    prevLocation.search === location.search
  ) {
    return
  }
  // Head API がタイトルを替えるのを待ってから送る。1フレームでは前のページのタイトルのまま送ることがある
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      setTimeout(() => trackPageView(location), 0)
    })
  })
}
